module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/fHIZLx/tc-custom/9781685624224.jpg?1705056297991",
      "alt": "This image is the cover for the book Fiercely Loyal"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Fiercely Loyal\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("Brother and sister, Sean and Colleen Callaghan share a relationship of love, loyalty, and perseverance. Their early childhood in a dysfunctional orphanage run by sisters focused on corporal punishment created a bond that carries them through a hard scrapple existence. Living through tough times in the Big Apple while concurrently 20th century history plays out, Sean and Colleen are challenged at every step.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("Sean grows from petty thief to booze-running during Prohibition, to waterfront dock boss. Colleen starts out running a speakeasy that transitions into an upscale restaurant catering to the well-heeled New York crowd, politicians, and Sean’s less-than-legit pals. The Callaghans’ saga spans pre-WWI to post WWII and is a true New York City story with colorful characters from waterfront toughs, bootleggers, slick gangsters, Nazi spies, and seductive women. When Sean is accused of murder and found guilty, the bond shared by the siblings is brought to its greatest test. The Callaghans are so fiercely loyal to each other their story will break your heart and keep you turning pages.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Deborah Ettinger\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Native New Yorkers, brother and sister team, Tom Johnson and Deborah Ettinger were inspired by the early life of their mother and uncle during the turbulent times of the Great Depression, Spanish Flu Pandemic, Prohibition and WWII. A graduate of Fordham University, Tom is a Bronze Star recipient and veteran of the Vietnam War. Deborah graduated from St Vincent’s School of Nursing and Hunter College. After highly successful careers in healthcare, Tom as assistant professor at Long Island University and Deborah as senior vice president of an international health system, they returned to their love of storytelling.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0